import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { SITE_ID } from '@/lib/constants';

export interface BankaHesabi {
  id: string;
  banka_adi: string;
  hesap_sahibi: string;
  iban: string;
  sube_adi?: string;
  aktif: boolean;
}

export interface PaymentSettings {
  kredi_karti_aktif: boolean;
  havale_aktif: boolean;
  kapida_odeme_aktif: boolean;
  kapida_odeme_ucreti: number;
  kapida_odeme_ust_limit: number;
  kargo_ucreti: number;
  ucretsiz_kargo_limiti: number;
  havale_talimatlari: string;
  banka_hesaplari: BankaHesabi[];
}

const DEFAULT_SETTINGS: PaymentSettings = {
  kredi_karti_aktif: true,
  havale_aktif: true,
  kapida_odeme_aktif: true,
  kapida_odeme_ucreti: 29,
  kapida_odeme_ust_limit: 0,
  kargo_ucreti: 49.9,
  ucretsiz_kargo_limiti: 500,
  havale_talimatlari: '',
  banka_hesaplari: [],
};

export function usePaymentSettings() {
  const [settings, setSettings] = useState<PaymentSettings>(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      const { data, error } = await supabase
        .from('odeme_ayarlari')
        .select(
          'kredi_karti_aktif, havale_aktif, kapida_odeme_aktif, kapida_odeme_ucreti, kapida_odeme_ust_limit, kargo_ucreti, ucretsiz_kargo_limiti, havale_talimatlari, banka_hesaplari'
        )
        .eq('site_id', SITE_ID)
        .maybeSingle();

      if (!error && data) {
        setSettings({
          kredi_karti_aktif: data.kredi_karti_aktif ?? true,
          havale_aktif: data.havale_aktif ?? true,
          kapida_odeme_aktif: data.kapida_odeme_aktif ?? true,
          kapida_odeme_ucreti: Number(data.kapida_odeme_ucreti) || 29,
          kapida_odeme_ust_limit: Number(data.kapida_odeme_ust_limit) || 0,
          kargo_ucreti: Number(data.kargo_ucreti) || 49.9,
          ucretsiz_kargo_limiti: Number(data.ucretsiz_kargo_limiti) || 500,
          havale_talimatlari: data.havale_talimatlari || '',
          banka_hesaplari: (data.banka_hesaplari as BankaHesabi[]) || [],
        });
      }
      setLoading(false);
    };

    fetchSettings();
  }, []);

  return { settings, loading };
}
